// extracted by mini-css-extract-plugin
export default {"input-checkbox":"Checkbox_input-checkbox__l+h4d"};